<div class="app-select">
  <div class="container">

    <div class="row">
      <div class="col-12 text-center">
        <div class="login-header text-center">
            <!-- placeholder for logo -->
        </div>
      </div>
    </div>
    <div class="row justify-content-center" [hidden]="loading">

      <div class="col-12 mb-5 col-md-6 col-lg-5"
           [hidden]="!principal.user?.roles.includes([userRoles.ADMIN, userRoles.CONTENT_OWNER, userRoles.SALES_REPRESENTATIVE]) && principal.user?.roles.includes(userRoles.READ_ONLY_ADMIN)">
        <div class="app-select-group">
          <h3 class="app-select-group-title">Main Dashboard</h3>
          <mat-card class="mb-3" *ngIf="principal.user?.roles.includes(userRoles.ADMIN) || principal.user?.roles.includes(userRoles.SALES_REPRESENTATIVE) || principal.user?.roles.includes(userRoles.READ_ONLY_ADMIN)">
            <mat-card-header (click)="mainDashboard()">
              <div mat-card-avatar class="">
                <i class="fal fa-user-tie"></i>
              </div>
              <mat-card-title class="text-uppercase">Main dashboard</mat-card-title>
              <div class="mat-card-header-action">
                <i class="fas fa-chevron-right" aria-hidden="true"></i>
              </div>
            </mat-card-header>
          </mat-card>
          <mat-card class="mb-3" *ngIf="principal.user?.roles.includes(userRoles.CAMPAIGN_MANAGER)">
            <mat-card-header (click)="campaignsDashboard()">
              <div mat-card-avatar class="">
                <i class="fal fa-user-tie"></i>
              </div>
              <mat-card-title class="text-uppercase">Campaigns dashboard</mat-card-title>
              <div class="mat-card-header-action">
                <i class="fas fa-chevron-right" aria-hidden="true"></i>
              </div>
            </mat-card-header>
          </mat-card>
          <mat-card class="mb-3" *ngIf="principal.user?.roles.includes(userRoles.REV_OPS)">
            <mat-card-header (click)="forecastDashboard()">
              <div mat-card-avatar class="">
                <i class="fal fa-user-tie"></i>
              </div>
              <mat-card-title class="text-uppercase">Forecast dashboard</mat-card-title>
              <div class="mat-card-header-action">
                <i class="fas fa-chevron-right" aria-hidden="true"></i>
              </div>
            </mat-card-header>
          </mat-card>
          <mat-card class="mb-3" *ngIf="principal.user?.roles.includes(userRoles.DESIGNER)">
            <mat-card-header (click)="designerDashboard()">
              <div mat-card-avatar class="">
                <i class="fal fa-user-tie"></i>
              </div>
              <mat-card-title class="text-uppercase">Designer dashboard</mat-card-title>
              <div class="mat-card-header-action">
                <i class="fas fa-chevron-right" aria-hidden="true"></i>
              </div>
            </mat-card-header>
          </mat-card>
        </div>

        <div class="app-select-group" *ngIf="principal.user?.roles.includes('CONTENT_OWNER')" [ngClass]="{'mt-5': principal.user?.roles.includes('ADMIN')}">
          <h3 class="app-select-group-title">Content Owner Dashboard</h3>
          <div class="data-loader" *ngIf="coLoading">
            <mat-spinner [color]="'primary'"
                         [mode]="'indeterminate'"
                         [diameter]="30">
            </mat-spinner>
          </div>
          <div *ngIf="contentOwners?.length && !coLoading">
            <mat-card class="mb-3" *ngFor="let co of contentOwners">
              <mat-card-header (click)="coDashboard(co.id)">
                <div mat-card-avatar class="">
                  <i class="fal fa-user-tie"></i>
                </div>
                <mat-card-title class="text-uppercase">{{co.name}}</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5 col-md-6 col-lg-5"
           [hidden]="!principal.user?.publisherIds || !principal.user?.publisherIds.length">
        <div class="data-loader" *ngIf="pubLoading">
          <mat-spinner [color]="'primary'"
                       [mode]="'indeterminate'"
                       [diameter]="30">
          </mat-spinner>
        </div>
        <div class="app-select-group" *ngIf="!pubLoading">
          <h3 class="app-select-group-title">Publisher Dashboards</h3>
          <div *ngIf="publishers?.length">
            <mat-card *ngFor="let p of publishers" class="mb-3">
              <mat-card-header (click)="selectPublisher(p.id)">
                <div mat-card-avatar class="">
                  <i class="fal fa-user"></i>
                </div>
                <mat-card-title class="text-uppercase">{{p.name}}</mat-card-title>
                <div class="mat-card-header-action">
                  <i class="fas fa-chevron-right" aria-hidden="true"></i>
                </div>
              </mat-card-header>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
